module.exports = __webpack_public_path__ + "static/media/htmlIcon.bc73a25b.svg";